import { ButterCmsPageSchema } from "./ButterCmsPageSchema"
import { ServicePageButton } from "./ServicePageButton"
import { ServicePageStep } from "./ServicePageStep"

type ServicePageItem = {
  picture: string
  short_description: string
  long_description: string
}

export enum ServiceCondition {
  MUST_BE_TRUE = "must-be-true",
  MUST_BE_FALSE = "must-be-false",
  CAN_BE_EITHER = "can-be-either",
}

type ServicePageDependentItem = ButterCmsPageSchema<
  ServicePageItem & {
    siab: ServiceCondition
    registry: ServiceCondition
  }
>

export type ServicePageWithDependenciesSchema = ButterCmsPageSchema<{
  title: string
  default_item: ServicePageItem
  items: ServicePageDependentItem[]
  buttons: ServicePageButton[]
  service_page_action_buttons: ServicePageButton[]
  service_page_steps: ServicePageStep[]
}>
